import React from 'react';
import './heroerror.css'
import pic40 from '../assets/pic40.png'
import { useState } from 'react';

const HeroError = () => {

 const [inView, setInView] = useState(false);

  const handleScroll = () => {
    const section = document.querySelector('.sec1-hero');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible !== inView) setInView(isVisible);
  };


  setTimeout(() => {
    handleScroll();
  }, 50);


    return ( 
        <section className='sec1-hero'>
            <article className='container-error'>
                    <img className={`picc-error ${inView ? 'animate' : ''}`} src={pic40} alt='pic'></img>

                    <article className={`container-text-error ${inView ? 'animate' : ''}`} >
                            <h1 className='header-error'>Error</h1>
                             <h1 className='header2-error'>404</h1>
                    </article>
            </article>
        </section>
     );
}
 
export default HeroError;